// FieldIncludeInQrPrintField.jsx

import React from 'react';

// Components
import Checkbox from 'components/checkbox/Checkbox';
import ModalField from 'components/modal/field/ModalField';
import ModalHint from 'components/modal/hint/ModalHint';
import ModalLabel from 'components/modal/label/ModalLabel';

/**
 * FieldIncludeInQrPrintField
 *
 * Toggle for including this field's value under the title on QR printouts.
 *
 * @param {boolean} includeInQrPrint - Whether the field is included on QR prints.
 * @param {function} onIncludeInQrPrintChange - Called with the next boolean value.
 *
 * @returns {ReactNode} The rendered control.
 */
const FieldIncludeInQrPrintField = ({
  includeInQrPrint,
  onIncludeInQrPrintChange,
}) => (

  <ModalField>

    <ModalLabel label="QR Print" />
    <ModalHint hint="When enabled, this field's value appears under the title on QR code stickers and printouts." />

    <Checkbox
      value={includeInQrPrint === true}
      size="22"
      label="Include when printing QR codes"
      onChange={() => onIncludeInQrPrintChange(!(includeInQrPrint === true))}
    />

  </ModalField>

);

// Dev Tools
FieldIncludeInQrPrintField.displayName = 'FieldIncludeInQrPrintField';

export default FieldIncludeInQrPrintField;
